import { AfterViewInit, ChangeDetectorRef, Component } from '@angular/core';
import { DateTime } from 'luxon';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements AfterViewInit {
  currentYear = DateTime.now().year;
  showCookiePopover = false;

  constructor(private modalService: ModalService, private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    const portalCookiesDismissedUntilString = sessionStorage.getItem('PortalCookieNoticeAccepted');

    if (portalCookiesDismissedUntilString == null) {
      this.showCookiePopover = true;
      this.cdr.detectChanges(); 
      return;
    }

    try {
      const portalCookiesDismissedUntilObject = JSON.parse(portalCookiesDismissedUntilString);
      const expiry = portalCookiesDismissedUntilObject.Timestamp;

      if (expiry <= DateTime.now().toUTC().toISO()) {
        this.showCookiePopover = true;
        this.cdr.detectChanges(); 
      }
    } catch {
      this.showCookiePopover = true;
      this.cdr.detectChanges(); 
    }
  }

  dismissCookiePopover() {
    const portalCookiesDismissedUntil = {
      Timestamp: DateTime.now().plus({months: 1}).toUTC().toISO()
    };

    sessionStorage.setItem('PortalCookieNoticeAccepted', JSON.stringify(portalCookiesDismissedUntil));
    this.showCookiePopover = false;
  }

  showPortalSecurityPopup() {
    this.modalService.showSecurityPrivacyCookiePolicyModal();
  }
}
